/**
 * Guest session token utility.
 * Generates a UUID and persists it in localStorage for the lifetime of the browser session.
 * Used as X-Session-Token header for unauthenticated cart operations.
 */

const SESSION_KEY = 'storefront-session-token';

export const getSessionToken = () => {
  let token = localStorage.getItem(SESSION_KEY);
  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, token);
  }
  return token;
};

export const clearSessionToken = () => {
  localStorage.removeItem(SESSION_KEY);
};
